<template>
  <div>
    <GroupHeader :width="460" :left="60" :top="130" :title="$t('Monitoring1025.meteoData')" />
    <div class="meteo-container" :style="{ width: width + 'px', height: height + 'px', left: left + 'px', top: top + 'px' }">
      <img class="met-bg" src="../../assets/images/1025/met-bg.png" />
      <div>
        <p class="tip-text tip1">{{ $t('Monitoring1025.windSpeed') }}</p>
        <p class="bold-text bold1">
          {{ windSpeedStart }}.
          <span class="small">{{ windSpeedEnd }}</span>
          m/s
        </p>
        <p class="tip-text tip2">{{ $t('Monitoring1025.temp') }}</p>
        <p class="bold-text bold2">
          {{ tempStart }}.
          <span class="small">{{ tempEnd }}</span>
          ℃
        </p>
        <p class="tip-text tip3">{{ $t('Monitoring1025.humidity') }}</p>
        <p class="bold-text bold3">
          {{ humidityStart }}.
          <span class="small">{{ humidityEnd }}</span>
          %
        </p>
        <p class="tip-text tip4">{{ $t('Monitoring1025.pressure') }}</p>
        <p class="bold-text bold4">
          {{ pressureStart }}.
          <span class="small">{{ pressureEnd }}</span>
          hPa
        </p>
        <img
          class="wind-circle"
          :style="{ transform: 'rotate(' + ((eqdata ? Number(eqdata['Wind Direction']).toFixed(1) : 0) - 90) + 'deg)' }"
          src="../../assets/images/1025/wind-circle.png"
        />
        <p class="temp-text">{{ eqdata ? Number(eqdata['Wind Direction']).toFixed(1) : '' }}°</p>
        <p class="wind-dirction-tip">{{ $t('Monitoring1025.windDirection') }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import GroupHeader from './GroupHeader.vue'

export default {
  props: {
    width: {
      type: Number,
      default: 460
    },
    height: {
      type: Number,
      default: 280
    },
    left: {
      type: Number,
      default: 60
    },
    top: {
      type: Number,
      default: 177
    },
    eqdata: {
      type: Object,
      default: null
    }
  },
  components: { GroupHeader },
  data() {
    return {}
  },
  methods: {
    dataStart(obj, key) {
      if (obj == null) return '0'
      let data = obj[key]
      let index = data.indexOf('.')
      if (index != -1) {
        let str = data.substr(0, index)
        return str
      } else {
        return '0'
      }
    },
    dataEnd(obj, key) {
      if (obj == null) return '0'
      let data = obj[key]
      let index = data.indexOf('.')
      if (index != -1) {
        let str = data.substr(index + 1, 1)
        return str
      } else {
        return '0'
      }
    }
  },
  computed: {
    windSpeedStart() {
      return this.dataStart(this.eqdata, window.guiyanaWindKey)
    },
    windSpeedEnd() {
      return this.dataEnd(this.eqdata, window.guiyanaWindKey)
    },
    tempStart() {
      return this.dataStart(this.eqdata, 'Temp(℃)')
    },
    tempEnd() {
      return this.dataEnd(this.eqdata, 'Temp(℃)')
    },
    humidityStart() {
      return this.dataStart(this.eqdata, 'Relative humidity')
    },
    humidityEnd() {
      return this.dataEnd(this.eqdata, 'Relative humidity')
    },
    pressureStart() {
      return this.dataStart(this.eqdata, 'Air Pressure(hPa)')
    },
    pressureEnd() {
      return this.dataEnd(this.eqdata, 'Air Pressure(hPa)')
    }
  },
  created() {},
  async mounted() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
.meteo-container {
  position: absolute;
  background: rgba(23, 78, 128, 0.22);
  color: #ffffff;
  .met-bg {
    z-index: 10;
    position: absolute;
    display: block;
    width: 404px;
    height: 232px;
    left: 28px;
    top: 24px;
  }

  .bold-text {
    position: absolute;
    z-index: 20;
    font-family: MyriadPro, MyriadPro;
    font-weight: normal;
    font-size: 24px;
    text-align: center;
    font-style: italic;
    word-spacing: -6px;
    .small {
      font-size: 12px;
    }
  }

  .tip-text {
    position: absolute;
    z-index: 20;
    font-family: Adobe Heiti Std;
    font-size: 14px;
    line-height: 35px;
    text-align: center;
    font-style: normal;
  }

  .tip1 {
    left: 29px;
    top: 80px;
    width: 89px;
    height: 28px;
  }

  .tip2 {
    right: 30px;
    top: 80px;
    width: 96px;
    height: 28px;
  }

  .tip3 {
    left: 29px;
    top: 140px;
    width: 89px;
    height: 28px;
  }

  .tip4 {
    right: 30px;
    top: 140px;
    width: 96px;
    height: 28px;
  }

  .bold1 {
    left: 29px;
    top: 35px;
    width: 98px;
  }

  .bold2 {
    right: 33px;
    top: 35px;
    width: 100px;
  }

  .bold3 {
    left: 29px;
    top: 170px;
    width: 110px;
    height: 28px;
  }

  .bold4 {
    right: 29px;
    top: 170px;
    width: 120px;
    height: 28px;
  }

  .wind-circle {
    position: absolute;
    position: absolute;
    left: 168px;
    top: 78px;
    width: 116px;
    height: 116px;
    z-index: 30;
    transform: rotate(45deg);
  }

  .temp-text {
    position: absolute;
    z-index: 50;
    font-family: MyriadPro, MyriadPro;
    font-weight: normal;
    font-size: 14px;
    text-align: center;
    font-style: italic;
    left: 180px;
    top: 190px;
    width: 80px;
  }

  .wind-dirction-tip {
    position: absolute;
    z-index: 60;
    font-family: MyriadPro, MyriadPro;
    font-weight: normal;
    font-size: 14px;
    text-align: center;
    width: 120px;
    left: 165px;
    top: 155px;
  }
}
</style>
